import { useNavigate } from 'react-router-dom';
import { DeleteModal, ModalContext } from 'dash-ui';

import { PropertyDetailsModalsEnum } from 'pages/properties/PropertyDetailsPage/PropertyDetailsPage.constants';
import {
  GetPropertiesDocument,
  useRemovePropertyByIdMutation,
} from 'gql/generated.graphql';
import { RoutesPath } from 'flow-components/routes/routes';
import { useContext } from 'react';

function DeletePropertyModal() {
  const navigate = useNavigate();
  const { payload } = useContext(ModalContext);

  const [removePropertyById, { loading }] = useRemovePropertyByIdMutation({
    refetchQueries: [GetPropertiesDocument],
  });

  async function submitPropertyDelete() {
    await removePropertyById({ variables: { propertyId: payload?._id } });
    navigate(RoutesPath.Properties);
  }

  return (
    <DeleteModal
      entity="Property"
      name={payload?.name}
      isLoading={loading}
      modalName={PropertyDetailsModalsEnum.DELETE_PROPERTY_MODAL}
      onClick={submitPropertyDelete}
    />
  );
}

export default DeletePropertyModal;
